<template>
    <jet-dialog-modal :show="true" @close="handleClose">
        <template #title>
            Daily Credit Limit Exceeded
        </template>

        <template #content>
            <div class="mb-2">
                While your application is pending approval, you are only allowed to use a maximum of {{ dailyLimitAvailabilityResponse.daily_max }} credits per day.
            </div>

            <ul 
                v-if="false"
                class="list-disc list-inside font-bold mb-4 mt-4">
                <li>
                    Daily Limit: {{ dailyLimitAvailabilityResponse.daily_max }} credits
                </li>
                <li>
                    Credits Used (24h): {{ dailyLimitAvailabilityResponse.used_today }}
                </li>
                <li>
                    Credits Available: {{ dailyLimitAvailabilityResponse.available }}
                </li>
            </ul>
            
            <div class="mb-2 mt-2">
                This message will exceed your daily credit limit.
                <br /><br />
                <span class="font-italic"></span>
            </div>
        </template>

        <template #footer>
            <a href="#" @click="openIntercom" class="mr-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900">Contact Support</a>
                
            <jet-button secondary @click.native="handleClose">
                OK
            </jet-button>
        </template>
    </jet-dialog-modal>
</template>

<script>
export default {
    name: 'DailyLimitWarningModal',
    props: ['dailyLimitAvailabilityResponse'],
    emits: ['close'],
    data() {
        return {
        }
    },
    methods: {
        handleClose() {
            this.$emit('close');
        },
        openIntercom() {
            window.Intercom('showNewMessage');
            this.handleClose();
        },
    },
}
</script>